import React, { useEffect, useMemo, useState, useRef } from 'react';
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Link } from 'react-feather';

import { View, ProcessLink, LastUpdate } from "./Case.style";
import { Container, Helmet } from "~/components";
import { Header } from '~/layout';
import HeaderBack from "~/layout/HeaderBack";
import { useFetch } from "~/hooks";
import { tabs } from "./data";
import CaseProgress from "./components/CaseProgress/CaseProgress";
import CaseCover from "./components/CaseCover/CaseCover";

import { Printer } from "react-feather";
import { useReactToPrint } from 'react-to-print';

const Case = () => {
  const { search } = useLocation();
  const { id: processID, riskID, caseNumber } = useParams();

  const query = new URLSearchParams(search).get('q') ?? 'cover';
  const { t } = useTranslation('diligence');

  const [caseUrl, setCaseUrl] = useState(null);
  const [lastVisit, setLastVisit] = useState(null);

  const { data: risks } = useFetch({ url: `/process/${processID}/risks/${riskID}` });
  const { data: processHeaders } = useFetch({ url: `/process/${processID}/headers` });

  const [isPrinting, setIsPriting] = useState(false);
  const [hasContent, setHasContent] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const caseCover = useMemo(() => {
    if (!risks) {
      return null;
    }

    const foundItem = risks.find(item => item.coluna2 === caseNumber);
    if (foundItem) {
      try {
        return JSON.parse(foundItem.popup);
      } catch (error) {
        console.error("Error parsing popup JSON:", error);
        return null;
      }
    }
    return null;
  }, [risks, caseNumber]);
  
  const entityName = useMemo(() => {
    if(!processHeaders) {
      return '';
    }
    
    return `${processHeaders?.data?.razaosocial} - `;
  }, [processHeaders])
  
  useEffect(() => {
    if(caseCover?.data?.CaseUrl) {
      setCaseUrl(caseCover.data.CaseUrl);
    }
    
    if (caseCover?.data?.LastVisit) {
      const [datePart, timePart] = caseCover.data.LastVisit.split(' ');
      const [year, month, day] = datePart.split('-');
      
      setLastVisit(`${day}/${month}/${year}, ${timePart}`);
    }
  }, [caseCover]);
  
  const tabComponents = {
    cover: <CaseCover caseCover={caseCover} />,
    progress: <CaseProgress caseNumber={caseNumber} isPrinting={isPrinting} infoLoading={setLoading} hasContent={setHasContent}/>
  };

  const popupWrapperRef = useRef(null);
  
  const handlePrint = useReactToPrint({
    content: () => popupWrapperRef.current,
    onAfterPrint: () => setIsPriting(false),
    pageStyle: `
      @media print {
        .no-print, .header {
          display: none !important; 
        }
      }
    `
  });
  
  useEffect(() => {
    if (isPrinting && !loading) {
      handlePrint();
    }
  }, [ loading ]);

  const PrepareToRetrieveAllTheData = () => {
    setIsPriting(true)
  }

  return (
    <View>
      <Helmet title={t("case_progress.title")} />

      <Container>
        <HeaderBack title={`${entityName} ${t("case_progress.case")}  ${caseNumber}`} hasArrow={false}>
          {caseUrl && (
            <ProcessLink target="_blank" href={caseUrl}>
              <Link size={16}/> {t("case_progress.case_url")}
            </ProcessLink>
          )}
        </HeaderBack>

        <Header query={query} className="header" head={tabs(t)}>
          {lastVisit && (
            <LastUpdate>{t("case_progress.last_visit")}: {lastVisit}</LastUpdate>
          )}
          {(!loading || hasContent) && <Printer onClick={PrepareToRetrieveAllTheData} style={{marginLeft: '2rem', cursor: 'pointer', marginBottom: '1.2rem'}}/>}
        </Header>
        
        {tabComponents[query] || tabComponents.cover}
      </Container>

      <div style={{display: 'none'}}>
        <Container ref={popupWrapperRef}>

          <HeaderBack title={`${entityName} ${t("case_progress.case")}  ${caseNumber}`} hasArrow={false}>
            {caseUrl && (
              <ProcessLink target="_blank" href={caseUrl}>
                <Link size={16}/> {t("case_progress.case_url")}
              </ProcessLink>
            )}
          </HeaderBack>

          <Header query={query} className="header" head={tabs(t)}>
            {lastVisit && (
              <LastUpdate>{t("case_progress.last_visit")}: {lastVisit}</LastUpdate>
            )}
          </Header>
          
          {tabComponents.cover}
          {tabComponents['progress']} 

        </Container>
      </div>
    </View>
  );
};

export default Case;
